
import SubscriptionMenu from './components/SubscriptionMenu';


export default {
  'subscriptions/components/SubscriptionMenu': SubscriptionMenu,
 
};
